import type { SVGProps } from 'react'
const SvgDashboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="15"
    height="14"
    viewBox="0 0 15 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.58491 4.66667V0H14.8071V4.66667H8.58491ZM0.807129 7.77778V0H7.02935V7.77778H0.807129ZM8.58491 14V6.22222H14.8071V14H8.58491ZM0.807129 14V9.33333H7.02935V14H0.807129ZM2.36268 6.22222H5.4738V1.55556H2.36268V6.22222ZM10.1405 12.4444H13.2516V7.77778H10.1405V12.4444ZM10.1405 3.11111H13.2516V1.55556H10.1405V3.11111ZM2.36268 12.4444H5.4738V10.8889H2.36268V12.4444Z"
      fill="#5E5E5E"
    />
  </svg>
)
export default SvgDashboard
